import { storageKey } from '@/services/types'
import type { ThemePreference, FontSizePreference } from '@/types/user-settings'

const THEME_KEY = storageKey('theme')
const FONT_SIZE_KEY = storageKey('font_size')

// =================== Theme ===================

export function getThemePreference(): ThemePreference {
  const stored = localStorage.getItem(THEME_KEY)
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored
  }
  return 'system'
}

export function setThemePreference(theme: ThemePreference): void {
  localStorage.setItem(THEME_KEY, theme)
}

// =================== Font Size ===================

export function getFontSizePreference(): FontSizePreference {
  const stored = localStorage.getItem(FONT_SIZE_KEY)
  if (stored === 'normal' || stored === 'large') {
    return stored
  }
  return 'normal'
}

export function setFontSizePreference(size: FontSizePreference): void {
  localStorage.setItem(FONT_SIZE_KEY, size)
}

// =================== Apply to DOM ===================

// 修复项：缓存 MediaQueryList 实例，避免每次 applyThemeToDOM 都重新创建对象并查询系统主题。
// prefers-color-scheme 在页面生命周期内不会变化，缓存后 system 模式下的切换性能更优。
const prefersDarkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

export function applyThemeToDOM(theme: ThemePreference): void {
  const root = document.documentElement
  if (theme === 'dark') {
    root.classList.add('dark')
  } else if (theme === 'light') {
    root.classList.remove('dark')
  } else {
    // system：复用缓存的 MediaQueryList 实例判断系统是否处于深色模式
    if (prefersDarkMediaQuery.matches) {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }
}

export function applyFontSizeToDOM(size: FontSizePreference): void {
  const root = document.documentElement
  if (size === 'large') {
    root.classList.add('font-large')
  } else {
    root.classList.remove('font-large')
  }
}
